import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AnalysisApiClientAccess } from '@nk/access-block';
import { CachingService } from '@nk/caching-lib';
import { AppFeatureKey, AppRoleKey, CompanyFraudRiskScoreEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FraudRiskScoreService {
  constructor(
    private _analysisApi: AnalysisApiClientAccess,
    private _cachingService: CachingService,
  ) {}

  public companyFraudRiskScoreListCache = this._cachingService.create(this, this.fetchCompanyFraudRiskScoreList);

  public fetchCompanyFraudRiskScoreList(companyIdentifier: string): Observable<CompanyFraudRiskScoreEntity[]> {
    return this._analysisApi.get<CompanyFraudRiskScoreEntity[]>(
      `company/${companyIdentifier}/company-fraud-risk-score`,
      {},
      [AppFeatureKey.base, AppFeatureKey.fraud_risk_score],
      [AppRoleKey.fraud_risk_score],
    );
  }

  public companyFraudRiskScoreListForCompaniesCache = this._cachingService.create(
    this,
    this.fetchCompanyFraudRiskScoreListForCompanies,
  );

  /**
   * Fraud risk scores for several companies in one request. Inactive companies are
   * omitted by the API, so the returned list may be shorter than the input.
   */
  public fetchCompanyFraudRiskScoreListForCompanies(
    companyIdentifiers: string[],
  ): Observable<CompanyFraudRiskScoreEntity[]> {
    const httpParams = new HttpParams().append('company_identifiers', companyIdentifiers.join(','));
    return this._analysisApi.get<CompanyFraudRiskScoreEntity[]>(
      'company-fraud-risk-score',
      { params: httpParams },
      [AppFeatureKey.base, AppFeatureKey.fraud_risk_score],
      [AppRoleKey.fraud_risk_score],
    );
  }
}
